<div class="border p-2">
  <signature-pad class="d-block w-100" [options]="signaturePadOptions"></signature-pad>
  <div class="d-flex align-items-center justify-content-end mt-2">
    <span class="text-success mr-3" *ngIf="captured">
      <i class="fas fa-check"></i> Signature ready
    </span>
    <button type="button" class="btn btn-secondary btn-thin mr-2" (click)="clearSignature()">
      <i class="fas fa-eraser"></i> Clear
    </button>
    <button type="button" class="btn btn-primary btn-thin" (click)="useSignature()">
      <i class="fas fa-check"></i> Use Signature
    </button>
  </div>
</div>
